import { ArticleFormItem, Warning } from '../Components/types';

const useArticlesModuleConstraints = () => {
    /** Compare article fields to determine if it's a duplicated article */
    const isDuplicate: (article: ArticleFormItem, articles: ArticleFormItem[]) => boolean = (
        article,
        articles = [],
    ) => {
        const sameOrBothEmpty = (value: unknown, valueKey: keyof ArticleFormItem): boolean => {
            const sameValue = value === article[valueKey];
            const bothEmpty = !value && !article[valueKey];

            return sameValue || bothEmpty;
        };

        const duplicateArticles = articles.filter(
            ({ id, articleId, label, price, invoicingCategory, subTypeId }) => {
                const excludeCurrentArticle = id !== article.id;
                const sameId = articleId === article.articleId;
                const labelSpecificArticle = invoicingCategory === 'LIB';

                return (
                    !labelSpecificArticle &&
                    excludeCurrentArticle &&
                    sameId &&
                    sameOrBothEmpty(label, 'label') &&
                    sameOrBothEmpty(price, 'price') &&
                    sameOrBothEmpty(subTypeId, 'subTypeId')
                );
            },
        );

        return duplicateArticles.length > 0;
    };

    /** Return article related warnings based on business logic */
    const getWarnings: (articleId: string, articles: ArticleFormItem[]) => Warning[] = (
        articleId,
        articles = [],
    ) => {
        const currentArticle = articles.find((articleItem) => articleItem.id === articleId);

        const missingStype =
            currentArticle?.originalArticle?.rubArticle === 'PUB' && !currentArticle.subTypeId;
        const duplicateArticle = isDuplicate(currentArticle as ArticleFormItem, articles);

        const emptySectionLabel =
            currentArticle?.invoicingCategory === 'LIB' && !currentArticle?.label;

        return [
            {
                condition: missingStype,
                name: 'missingSType',
                message: 'Veuillez selectionner un sous-type pour cet article',
            },
            {
                condition: duplicateArticle,
                name: 'duplicate',
                message: 'Cet article est dupliqué',
            },
            {
                condition: emptySectionLabel,
                name: 'emptySection',
                message: 'Le titre de la section est vide',
            },
        ];
    };

    return { isDuplicate, getWarnings };
};

export default useArticlesModuleConstraints;
